import React, { FC } from 'react';
import { Box, Switch, Flex } from '@chakra-ui/react';
import { Props } from './type';
import { Checkbox } from '../Checkbox';
import { Radio } from '../Radio';

export const SelectionControl: FC<Props> = props => {
  const {
    children,
    isDisabled,
    hideLabel,
    name,
    inputRef,
    id,
    key,
    onChange,
    onClick,
    labelAction,
    padding: userPadding = {},
    isChecked,
    stacked,
    type,
    value,
    toggleLabelSide,
    label,
  } = props;

  const padding = {
    ...{ pt: 0, pr: 4, pb: 0, pl: 0 },
    ...userPadding,
  };

  let currentType = type;
  if (type === 'checkbox' || type === 'option') {
    currentType = 'checkbox';
  } else if (type === 'switch' || type === 'toggle') {
    currentType = 'toggle';
  }

  const filteredDataAttibsInputProps = (): { [key: string]: any } => {
    // This will be props for the input of the Chakra component (inputProps).
    // Filter out anything other than data attributes to avoid errors.
    const result: { [key: string]: any } = {};
    for (const key in props) {
      if (key.startsWith('data-')) {
        result[key] = props[key as keyof typeof props];
      }
    }
    /**
     * The currentType will, in the end, only be checkbox, radio, or toggle
     * to keep it predictible for testing suits
     */
    result['data-component-type'] = currentType;
    return result;
  };

  const isItChecked = isChecked ?? false;

  const commonProps = {
    isDisabled,
    name,
    ref: inputRef,
    id,
    key,
    onChange,
    isChecked: isItChecked,
    'data-action': labelAction,
    value,
    ...filteredDataAttibsInputProps(),
  };

  const renderElement = () => {
    if (currentType === 'checkbox') {
      return (
        <Box {...padding}>
          <Flex align="start">
            <Box alignItems={stacked ? 'center' : 'left'}>
              <Checkbox label={label} gap="2" {...commonProps} variant={stacked ? 'stacked' : undefined}>
                {children}
              </Checkbox>
            </Box>
          </Flex>
        </Box>
      );
    } else if (currentType === 'radio') {
      return (
        <Flex align={stacked ? 'center' : 'start'} direction={stacked ? 'column' : 'row'}>
          <Radio
            label={label}
            gap="2"
            {...commonProps}
            onClick={onClick}
            role="radio"
            variant={stacked ? 'stacked' : undefined}
          >
            {children}
          </Radio>
        </Flex>
      );
    } else if (currentType === 'toggle') {
      let labelSide = children && !toggleLabelSide ? 'right' : toggleLabelSide;
      labelSide = !hideLabel && React.Children.count(children) > 0 ? labelSide : '';

      return (
        <Box display="flex" alignItems="center" {...padding}>
          <Flex align={stacked ? 'center' : 'start'} direction={stacked ? 'column' : 'row'}>
            {labelSide === 'left' && (
              <Box mr="2" {...filteredDataAttibsInputProps()}>
                {children}
              </Box>
            )}
            <Switch {...commonProps} />
            {labelSide === 'right' && (
              <Box ml="2" mt={stacked ? 2 : 0} {...filteredDataAttibsInputProps()}>
                {children}
              </Box>
            )}
          </Flex>
        </Box>
      );
    }
  };

  return <>{renderElement()}</>;
};
